// @ts-nocheck
import { useRequestQuery } from '../../useQueryRequest';
import { transformToCamelCase } from '@/utils';
import t from '@/store/financialStatement/financialStatements.types';

const STALE_TIME = 1000 * 60 * 5; // 5 minutes

/**
 * Retrieve AP non-bill transactions details.
 */
export function useAPNonBillTransactions(query, props) {
  return useRequestQuery(
    [t.AP_AGING_SUMMARY, 'non-bill-transactions', query],
    {
      method: 'get',
      url: 'financial_statements/payable_aging_summary/non-bill-transactions',
      params: query,
    },
    {
      select: (res) => {
        console.log('Raw AP API Response:', res);
        console.log('AP Response data:', res.data);
        console.log('AP Response data.data:', res.data?.data);
        const transformedData = transformToCamelCase(res.data?.data);
        console.log('Transformed AP data:', transformedData);
        return transformedData;
      },
      staleTime: STALE_TIME,
      ...props,
    }
  );
}
